import React, {useState} from 'react'
import {VoteState} from '@colonist/game-state-types'
import {UIGameVote} from './UIGameVote'
import {useUIGameSocketContext} from '../../contexts/UIGameSocketContext'
import {useUIGameMyColorContext} from '../../contexts/UIGameMyColorContext'
import {useUIContext} from '../../contexts/UIContext'

let globalVoteStateSetter: undefined | ((voteState: VoteState | null) => void)
export function setGlobalVoteState(voteState: VoteState | null) {
    if(globalVoteStateSetter) globalVoteStateSetter(voteState)
}

export interface UIGameVoteProps {
    className?: string
    setLogVisible?: (isVisible: boolean) => void
    setChatVisible?: (isVisible: boolean) => void
}

export const UIGameVoteContainer = ({className, setLogVisible, setChatVisible}: UIGameVoteProps) => {
    const {isUserOnMobile} = useUIContext()
    const [voteState, setVoteState] = useState<VoteState | null>(null)
    const {sendVote} = useUIGameSocketContext()
    const {myColor} = useUIGameMyColorContext()

    const updateVoteState = (vote: VoteState) => {
        setVoteState(vote)
        setLogVisible?.(false)
        if(isUserOnMobile) { // Old Mobile Landscape
            setChatVisible?.(false)
        }
    }

    const onReceiveVoteState = (newVoteState: VoteState) => {
        if(newVoteState.done) {
            setVoteState(null)
            setLogVisible?.(true)
            setChatVisible?.(true)
        } else {
            const hasActiveVote = voteState != null

            const allVotes = [...newVoteState.acceptedVotes, ...newVoteState.declinedVotes]
            const hasMyColorAlreadyVoted = allVotes.includes(myColor)
            if(!hasMyColorAlreadyVoted && !hasActiveVote || hasActiveVote) {
                updateVoteState(newVoteState)
            }
        }
    }

    globalVoteStateSetter = onReceiveVoteState

    const castVote = (accepted: boolean) => {
        if(voteState == null) return
        if(accepted) {
            setVoteState({
                ...voteState,
                acceptedVotes: [...voteState.acceptedVotes, myColor],
            })
        } else {
            setVoteState({
                ...voteState,
                declinedVotes: [...voteState.declinedVotes, myColor],
            })
        }
        sendVote(voteState.id, accepted)
    }
    const onAccept = () => castVote(true)
    const onReject = () => castVote(false)

    if(voteState == null) return null
    return (
        <UIGameVote
            onAccept={onAccept}
            onReject={onReject}
            voteState={voteState}
            className={className}/>
    )
}
